export const statusStyles = {
  OK: "bg-brand-magenta text-white",
  "Needs Update": "bg-amber-300 text-slate-900",
  Error: "bg-red-500 text-white",
};

export function renderStatusPill(status) {
  const cls = statusStyles[status] || "bg-slate-600 text-slate-100";
  return (
    <span className={`inline-flex items-center justify-center rounded-full px-2.5 py-1 text-[10px] font-semibold shadow ${cls}`}>
      {status}
    </span>
  );
}

export function nodeIconForType(type = "") {
  const t = type.toLowerCase();
  if (t.includes("bms")) return "battery_charging_full";
  if (t.includes("mppt") || t.includes("solar")) return "wb_sunny";
  if (t.includes("dcdc")) return "bolt";
  if (t.includes("shunt")) return "electric_meter";
  return "cable";
}

export function InfoTile({ label, value }) {
  return (
    <div className="rounded-xl border border-brand-navy bg-brand-navy px-3 py-2.5 flex flex-col gap-0.5">
      <span className="text-[10px] font-semibold tracking-widest text-brand-light/40 uppercase">{label}</span>
      <span className="text-sm font-semibold text-brand-light">{value}</span>
    </div>
  );
}
